import { IndicatorLabel } from 'components/IndicatorLabel';
import { formatDate } from 'utils/dates';
import { PatientMeasurement } from 'utils/models';

interface Props {
  measurement?: PatientMeasurement;
  formatWithTime?: boolean;
}

export const IndicatorLabelWithTimestamp = ({ measurement, formatWithTime }: Props) => {
  if (!measurement) return null;

  return (
    <IndicatorLabel
      indicator={measurement.indicator}
      label={formatDate({ timestamp: measurement.timestamp, formatWithTime })}
    />
  );
};
